import { useCallback } from "react";
import apiClient from "src/api/axiosClient";
import {
  CampaignCreateOptionsSearchParams,
  CampaignCreateOptionsSearchResponse,
} from "./types";

export function useGetCampaignCreateOptionsApi() {
  return useCallback(
    (
      params: CampaignCreateOptionsSearchParams
    ): Promise<{ data: CampaignCreateOptionsSearchResponse }> =>
      apiClient.get(`/applications/campaign-create-options`, { params }),
    []
  );
}
